import { useLocation } from 'react-router-dom';
import ConfigCrudPage from '../../components/common/ConfigCrudPage';
import { getConfigCrudDefinition } from './configCrudDefinitions';

const ValidationRules = () => {
  const location = useLocation();
  const entityType = location.pathname.includes('/configuration/drug/') ? 'drug' : 'hcp';
  const config = getConfigCrudDefinition(entityType, 'validation-rules');

  return (
    <ConfigCrudPage
      title={config.title}
      subtitle={config.subtitle}
      storageKey={config.storageKey}
      storageVersion={config.storageVersion}
      seedRows={config.seedRows}
      columns={config.columns}
      fields={config.fields}
    addButtonLabel={config.addButtonLabel}
    />
  );
};

export default ValidationRules;

